var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AlignBottom",
    clipPath: "url(#clip0_2293_6007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.25 20.75H3.75",
    stroke: "#6A49DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5 8V17C13.5 17.4142 13.8358 17.75 14.25 17.75H18C18.4142 17.75 18.75 17.4142 18.75 17V8C18.75 7.58579 18.4142 7.25 18 7.25H14.25C13.8358 7.25 13.5 7.58579 13.5 8Z",
    stroke: "#6A49DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.75 3.5H6C5.58579 3.5 5.25 3.83579 5.25 4.25V17C5.25 17.4142 5.58579 17.75 6 17.75H9.75C10.1642 17.75 10.5 17.4142 10.5 17V4.25C10.5 3.83579 10.1642 3.5 9.75 3.5Z",
    stroke: "#6A49DB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2293_6007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardsIcon);
export default __webpack_public_path__ + "static/media/standardsIcon.680dbb48aa86f152a065dd8c0a3aa16b.svg";
export { ForwardRef as ReactComponent };